<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <h4 v-if="editName == ''" class="p-d-flex p-ai-baseline">{{ client.name }} <Button icon="pi pi-pencil" class="p-button-link" @click="editName = client.name" /></h4>
                <div class="p-inputgroup p-lg-4 p-md-6 p-p-0 p-mb-2" v-else>
                    <Button label="Cancel" @click="editName = false" class="p-button-link p-order-1" />
                    <InputText type="text" class="p-inputtext-lg" placeholder="Large" v-model="editName" autofocus />
                    <Button icon="pi pi-save" @click="saveName" class="p-button-primary p-button-lg" />
                </div>
                <!-- <p>Description of client.</p> -->
                <DataTable :value="clientSites" :paginator="true" class="p-mb-4" :rows="10" dataKey="key" :rowClass="rowClass" :rowHover="true" :filters="filters" :loading="loading" sortField="name" :sortOrder="1">
                    <template #header>
                        <div class="p-d-md-flex p-jc-md-between">
                            List of Sites
                            <div>
                                <span class="p-input-icon-left p-mt-2 p-ml-md-2">
                                    <i class="pi pi-search" />
                                    <InputText v-model="filters['global'].value" placeholder="Site Search" />
                                </span>
                            </div>
                        </div>
                    </template>
                    <template #empty>
                        No sites found.
                    </template>
                    <template #loading>
                        Loading sites data. Please wait.
                    </template>
                    <Column field="name" header="Name" :sortable="true">
                        <template #body="slotProps">
                            <router-link v-if="(user.data.assignedSites.includes(slotProps.data.key) || (user.data.role.permissionLevel >= 8))" :to="{ name: 'site', params: { client_id: client.key, id: slotProps.data.key } }">{{
                                slotProps.data.name
                                }}</router-link>
                            <span v-else>{{ slotProps.data.name }}</span>
                        </template>
                    </Column>
                    <Column headerClass="table__button--header" bodyClass="table__button">
                        <template #body="slotProps">
                            <!-- <Button type="button" icon="pi pi-cog" class="p-button-secondary"></Button> -->
                            <Button type="button" icon="pi pi-angle-down" v-if="((user.data.role.permissionLevel >= 8))" @click="toggleMenu($event, slotProps.data.key, slotProps.data)" class="p-button-secondary" />
                            <Button disabled v-else icon="pi pi-angle-down" class="p-button-secondary"></Button>
                        </template>
                    </Column>
                </DataTable>
                <Menu ref="menu" :model="overlayMenuItems.items" :popup="true" />
                <Dialog header="Confirmation" :visible.sync="displayConfirmation" :style="{ width: '350px' }" :modal="true">
                    <div class="confirmation-content">
                        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
                        <span>Are you sure you want to proceed?</span>
                    </div>
                    <template #footer>
                        <Button label="No" icon="pi pi-times" @click="closeConfirmation(false)" class="p-button-text" />
                        <Button label="Yes" icon="pi pi-check" @click="closeConfirmation(true)" class="p-button-text" autofocus />
                    </template>
                </Dialog>
                <div class="p-d-flex p-jc-end">
                    <Button label="New Site" icon="pi pi-plus" class="p-button-secondary" @click="visibleRight = true" v-if="(user.data.role.permissionLevel >= 10)" iconPos="right" />
                    <Sidebar :visible.sync="visibleRight" :baseZIndex="1000" position="right" v-if="(user.data.role.permissionLevel >= 10)">
                        <ValidationObserver v-slot="{ handleSubmit }" slim ref="selected">
                            <form @submit.prevent="handleSubmit(addSite())">
                                <h1 style="fontWeight:normal">Add Site</h1>
                                <div class="p-my-4">
                                    <!-- <InputText id="name" type="text" v-model="selected.name" /> -->
                                    <ValidationProvider name="Site name" :rules="{ required: true }" v-slot="{ errors }">
                                        <div class="p-float-label">
                                            <InputText type="text" :class="{ 'p-invalid': errors.length > 0 }" class="p-inputtext p-d-block" v-model="selected.name" />
                                            <label for="name">Site Name</label>
                                        </div>
                                        <small id="" class="p-error p-d-block" v-if="errors[0]">{{ errors[0] }}</small>
                                    </ValidationProvider>
                                </div>
                                <div class="p-my-4">
                                    <!-- <InputText id="site_contact" type="text" v-model="selected.contact" /> -->
                                    <ValidationProvider name="Contact name" v-slot="{ errors }">
                                        <div class="p-float-label">
                                            <InputText type="text" :class="{ 'p-invalid': errors.length > 0 }" class="p-inputtext p-d-block" v-model="selected.contact" />
                                            <label for="site_contact">Site Contact</label>
                                        </div>
                                        <small id="" class="p-error p-d-block" v-if="errors[0]">{{ errors[0] }}</small>
                                    </ValidationProvider>
                                </div>
                                <div class="p-my-4">
                                    <!-- <InputText id="site_mobile" type="text" v-model="selected.mobile" /> -->
                                    <ValidationProvider name="Site contact mobile" :rules="{ regex: /^07/, length: 11, integer: true }" v-slot="{ errors }">
                                        <div class="p-float-label">
                                            <InputText type="text" :class="{ 'p-invalid': errors.length > 0 }" class="p-inputtext p-d-block" v-mask="'###########'" v-model="selected.mobile" />
                                            <label for="site_mobile">Site Contact Mobile</label>
                                        </div>
                                        <small id="" class="p-error p-d-block" v-if="errors[0]">{{ errors[0] }}</small>
                                    </ValidationProvider>
                                </div>
                                <div class="p-my-4">
                                    <!-- <InputText id="site_address" type="text" v-model="selected.address" /> -->
                                    <ValidationProvider name="Site address" v-slot="{ errors }">
                                        <div class="p-float-label">
                                            <InputText type="text" :class="{ 'p-invalid': errors.length > 0 }" class="p-inputtext p-d-block" v-model="selected.address" />
                                            <label for="site_address">Site Address</label>
                                        </div>
                                        <small id="" class="p-error p-d-block" v-if="errors[0]">{{ errors[0] }}</small>
                                    </ValidationProvider>
                                </div>
                                <div class="p-my-4">
                                    <!-- <InputText id="site_maintel" type="text" v-model="selected.mainTel" /> -->
                                    <ValidationProvider name="Main telephone number" :rules="{ length: 11, integer: true }" v-slot="{ errors }">
                                        <div class="p-float-label">
                                            <InputText type="text" :class="{ 'p-invalid': errors.length > 0 }" class="p-inputtext p-d-block" v-mask="'###########'" v-model="selected.mainTel" />
                                            <label for="site_maintel">Site Main Telephone</label>
                                        </div>
                                        <small id="" class="p-error p-d-block" v-if="errors[0]">{{ errors[0] }}</small>
                                    </ValidationProvider>
                                </div>
                                <div class="p-my-4">
                                    <!-- <InputText id="site_mainemail" type="text" v-model="selected.mainEmail" /> -->
                                    <ValidationProvider name="Main email address" :rules="{ email: true }" v-slot="{ errors }">
                                        <div class="p-float-label">
                                            <InputText type="text" :class="{ 'p-invalid': errors.length > 0 }" class="p-inputtext p-d-block" v-model="selected.mainEmail" />
                                            <label for="site_mainemail">Site Main Email</label>
                                        </div>
                                        <small id="" class="p-error p-d-block" v-if="errors[0]">{{ errors[0] }}</small>
                                    </ValidationProvider>
                                </div>
                                <div class="p-my-4">
                                    <!-- <InputText id="site_areacontact" type="text" v-model="selected.areaContact" /> -->
                                    <ValidationProvider name="Area contact name" v-slot="{ errors }">
                                        <div class="p-float-label">
                                            <InputText type="text" :class="{ 'p-invalid': errors.length > 0 }" class="p-inputtext p-d-block" v-model="selected.areaContact" />
                                            <label for="site_areacontact">Site Area Contact</label>
                                        </div>
                                        <small id="" class="p-error p-d-block" v-if="errors[0]">{{ errors[0] }}</small>
                                    </ValidationProvider>
                                </div>
                                <div class="p-my-4">
                                    <!-- <InputText id="site_areaemail" type="text" v-model="selected.areaEmail" /> -->
                                    <ValidationProvider name="Area email address" :rules="{ email: true }" v-slot="{ errors }">
                                        <div class="p-float-label">
                                            <InputText type="text" :class="{ 'p-invalid': errors.length > 0 }" class="p-inputtext p-d-block" v-model="selected.areaEmail" />
                                            <label for="site_areaemail">Site Area Email</label>
                                        </div>
                                        <small id="" class="p-error p-d-block" v-if="errors[0]">{{ errors[0] }}</small>
                                    </ValidationProvider>
                                </div>
                                <div class="p-my-4">
                                    <!-- <InputText id="site_areamobile" type="text" v-model="selected.areaMobile" /> -->
                                    <ValidationProvider name="Area mobile number" :rules="{ regex: /^07/, length: 11, integer: true }" v-slot="{ errors }">
                                        <div class="p-float-label">
                                            <InputText type="text" :class="{ 'p-invalid': errors.length > 0 }" class="p-inputtext p-d-block" v-mask="'###########'" v-model="selected.areaMobile" />
                                            <label for="site_areamobile">Site Area Mobile</label>
                                        </div>
                                        <small id="" class="p-error p-d-block" v-if="errors[0]">{{ errors[0] }}</small>
                                    </ValidationProvider>
                                </div>

                                <Button type="button" @click="addSite" label="Save" class="p-button-success" style="margin-right:.25em" />
                                <Button type="button" @click="visibleRight = false, selected = {
                                    name: '',
                                    key: '',
                                    contact: '',
                                    mobile: '',
                                    address: '',
                                    mainTel: '',
                                    mainEmail: '',
                                    areaContact: '',
                                    areaEmail: '',
                                    areaMobile: ''
                                };" label="Cancel" class="p-button-secondary" />
                            </form>
                        </ValidationObserver>
                    </Sidebar>
                </div>
            </div>
        </div>
        <Toast />
    </div>
</template>

<script>
import { db } from '@/firebase';
import { ValidationProvider } from 'vee-validate';
import { ValidationObserver } from 'vee-validate';
import { mapGetters } from "vuex";
import { FilterMatchMode } from 'primevue/api';
import axios from 'axios';

import { extend } from 'vee-validate';
import { required, length, email, integer, max, regex } from 'vee-validate/dist/rules';

extend('required', {
    ...required,
    message: (fieldName) => {
        return `Please enter your ${fieldName.toLowerCase()}`;
    }
});
extend('length', length);
extend('integer', integer);
extend('regex', regex);
extend('max', max);
extend('email', {
    ...email,
    message: 'Please enter a valid email address'
});

import { configure } from 'vee-validate';

configure({
    classes: {
        valid: 'is-valid',
        invalid: 'is-invalid',
        dirty: ['is-dirty', 'is-dirty'], // multiple classes per flag!
        // ...
    }
})

export default {
    components: {
        ValidationProvider,
        ValidationObserver
    },
    data() {
        return {
            filters: { global: { value: null, matchMode: FilterMatchMode.CONTAINS } },
            loading: true,
            clientSites: [],
            client: {},
            selected: {
                name: '',
                key: '',
                contact: '',
                mobile: '',
                address: '',
                mainTel: '',
                mainEmail: '',
                areaContact: '',
                areaEmail: '',
                areaMobile: ''
            },
            editName: false,
            visibleRight: false,
            displayConfirmation: false,
            overlayMenuItems: {
                id: null,
                items: [
                    {
                        label: 'View/Edit',
                        icon: 'pi pi-pencil'
                    },
                    {
                        label: 'Delete',
                        icon: 'pi pi-trash'
                    },
                ],
            },
        }
    },
    firestore() {
        return {
            client: db.collection('clients').doc(this.$route.params.id),
            clientSites: {
                ref: db.collection('sites').where('client_id', '==', this.$route.params.id),
                resolve: (data) => {
                    data.forEach((site, index) => {
                        db.collection('assets').where('site_id', '==', site.key).where('client_id', '==', this.$route.params.id).onSnapshot((query) => {
                            this.clientSites[index].assetCount = query.size; // for deletion validation in openConfirmation
                        })
                    })
                    this.loading = false
                },
                reject: (error) => {
                    this.loading = false;
                    console.error({ error })
                    this.$router.push('/');
                }
            },
            sites: db.collection('sites'),
        }
    },
    watch: {
        '$route.params.id'(id) {
            // $bind automatically unbinds the previously bound property
            this.$binding("client", db.collection("clients").doc(this.$route.params.id));
            this.$binding("clientSites", db.collection("sites").where('client_id', '==', this.$route.params.id));
        },
    },
    methods: {
        rowClass(data) {
            // console.log(this.user.data.assignedSites);
            return (!this.user.data.assignedSites.includes(data.key) && this.user.data.role.permissionLevel <= 6) ? 'hide' : null;
        },
        toggleMenu(event, id, meta) {
            this.overlayMenuItems = {};
            this.overlayMenuItems = {
                id: id,
                items: [
                    {
                        label: 'View/Edit',
                        icon: 'pi pi-pencil',
                        to: { name: 'site', params: { client_id: this.client.key, id: id } }
                    },
                    {
                        label: 'Delete',
                        icon: 'pi pi-trash',
                        command: (event) => {
                            this.openConfirmation(event, meta)
                        }
                    },
                ]
            }
            this.$refs.menu.toggle(event);
        },
        openConfirmation(event, meta) {
            if (meta && !meta.assetCount) {
                this.selected = meta;
                this.displayConfirmation = true;
            } else {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Site still has assigned assets. Remove all assets from this site before deleting.', life: 3000 });
            }
        },
        closeConfirmation(confirm) {
            if (confirm) {
                db.collection('site_bin').doc(this.selected.key).set({ // write new doc to bin collection
                    metadata: this.selected,
                    deleted_timestamp: new Date(),
                }).then(() => {
                    this.$firestore.sites.doc(this.selected.key).delete().then(() => { // once written to bin, delete from sites collection
                        console.log(this.selected)
                        db.collection('logs').add({
                            activity: 'Site deleted',
                            timestamp: new Date(),
                            user: this.user.data.email,
                            client_id: this.user.data.client.key,
                            site: this.selected.name
                        }).then(() => {
                            // filters shoudl already be empty for this, as you need to remove all assets before deletion is possible
                            this.selected = '';
                            this.displayConfirmation = false;
                            this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Site deleted', life: 3000 });
                        });
                    });
                });
            }
            this.displayConfirmation = false;
        },
        addSite: function () {
            this.$refs.selected.validate().then(success => {
                if (success) {
                    this.$firestore.sites.add({
                        name: this.selected.name,
                        client_id: this.$route.params.id,
                        timestamp: new Date(),
                        last_id: '-',
                        contact: this.selected.contact,
                        mobile: this.selected.mobile,
                        address: this.selected.address,
                        main_tel: this.selected.mainTel,
                        main_email: this.selected.mainEmail,
                        area_contact: this.selected.areaContact,
                        area_email: this.selected.areaEmail,
                        area_mobile: this.selected.areaMobile
                    }).then((data) => {
                        const filterSetUrl = process.env.VUE_APP_API_URL + '/filter/set';

                        axios({
                            method: 'post',
                            url: filterSetUrl,
                            headers: {
                                'Authorization': `Bearer ${this.user.auth.accessToken}`
                            },
                            data: {
                                'siteId': data.id,
                            }
                        }).then((response) => {
                        }).catch(error => { console.error(error) });

                        // Clear all form fields
                        this.selected = {
                            name: '',
                            key: '',
                            contact: '',
                            mobile: '',
                            address: '',
                            mainTel: '',
                            mainEmail: '',
                            areaContact: '',
                            areaEmail: '',
                            areaMobile: ''
                        };
                        this.visibleRight = false;

                        db.collection('logs').add({
                            activity: 'New site added',
                            timestamp: new Date(),
                            user: this.user.data.email,
                            client_id: this.user.data.client.key
                        }).then(() => {
                            this.$toast.add({ severity: 'success', summary: 'Success', detail: 'New site added', life: 3000 });
                        });
                    });
                }
            });
        },
        saveName() {
            this.$firestore.client.update({ 'name': this.editName }).then(() => {

                db.collection('users').where('client.key', '==', this.$route.params.id).get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {

                        // Update the document
                        db.collection('users').doc(doc.id).update({
                            'client.name': this.editName
                        })
                    });

                    let userMeta = JSON.parse(localStorage.getItem('vuex'));
                    userMeta.user.data.client.name = this.editName;
                    localStorage.setItem('vuex', JSON.stringify(userMeta));

                    this.editName = '';

                    db.collection('logs').add({
                        activity: 'Client name updated',
                        timestamp: new Date(),
                        user: this.user.data.email,
                        client_id: this.user.data.client.key
                    }).then(() => {
                        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Client name updated', life: 3000 });
                    });
                }).catch((error) => {
                    console.error('Error getting documents: ', error);
                });
            });
        }
    },
    computed: {
        // map `this.user` to `this.$store.getters.user`
        ...mapGetters({
            user: "user"
        })
    }
}
</script>

<style lang="scss">
tr.hide {
    display: none;
    visibility: hidden;
}
</style>
